import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import styles from "./Score.scss";

const propTypes = {
  color: PropTypes.string,
  numerator: PropTypes.number,
  denominator: PropTypes.number,
  scoreLabel: PropTypes.node,
};

const defaultProps = {
  color: "#ccc",
  numerator: 0,
  denominator: 0,
  scoreLabel: null,
};

function Score(props) {
  const { color, numerator, denominator, scoreLabel } = props;

  return (
    <div className={styles["score-container"]}>
      <span
        className="font-bolder"
        style={{
          fontSize: "6rem",
          color,
        }}
      >
        {numerator}
      </span>
      <span
        className="font-bolder"
        style={{
          color,
          fontSize: "2rem",
        }}
      >
        /{denominator}
      </span>

      {scoreLabel !== undefined && (
        <span className={clsx(styles["score-label"], "font-color-6")}>
          {scoreLabel}
        </span>
      )}
    </div>
  );
}

Score.propTypes = propTypes;
Score.defaultProps = defaultProps;

export default Score;
